//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import defaultUserImage from "../../../assets/images/user.svg";

export default {
    name: "FabDrawerMenuAction",
    props: {
        icon: { type: String, default: null },
        img: { type: String, default: null },
        badge: { type: Number, default: 0 }
    },
    methods: {
        onImageError(ev) {
            ev.target.src = defaultUserImage;
        }
    }
};
